//ゲストのエンドポイント
const apiBasePath = process.env.APP_API_PATH;
const apiBasePathGuest = `${apiBasePath}/guest`;

export const GUEST_END_POINTS = {
  TASK: {
    VENUE_TYPE: `${apiBasePathGuest}/venuetype` //物件タイプ一覧取得
  },
  CONTACT: {
    FILE_UPLOAD: {
      CREW: {
        SINGLE: `${apiBasePathGuest}/crew/inquiry/upload-file`, //クルー単一ファイルアップロード
        MULTIPLE: `${apiBasePathGuest}/crew/inquiry/upload-files`, //クルー複数ファイルアップロード
        DELETE: `${apiBasePathGuest}/crew/inquiry/delete-file` //クルーファイル削除
      },
      OWNER: {
        SINGLE: `${apiBasePathGuest}/owner/inquiry/upload-file`, //依頼者単一ファイルアップロード
        MULTIPLE: `${apiBasePathGuest}/owner/inquiry/upload-files`, //依頼者複数ファイルアップロード
        DELETE: `${apiBasePathGuest}/owner/inquiry/delete-file` //依頼者ファイル削除
      }
    }
  }
};
